import Ctrl from 'ctrl.deco';

@Ctrl('/settings/access_levels/employee/:id')
class SettingsAccessLevelsEmployeeCtrl {

	get levelId() {
		return this._params.id;
	}
}
